import React from 'react';
import { Form } from '../Components/Form';

import { HeroImg2 } from '../Components/HeroImg2';
import { Navbar } from '../Components/Navbar'

export const Contact = () => {
  return (
    <div>
      <Navbar />
      <HeroImg2 heading="CONTACT" text="Let's have a chat"/>
      <Form />
      <div style={{height:"250px",backgroundColor:"gray",display:"flex",alignItems:"center",justifyContent:"center"}}>
        <h2 style={{textAlign:"center",color:"yellow"}}>All copyrights reserved to © Rajesh Kumar</h2>
      </div>
    </div>
  )
}
